(function ($) {
  if (!$) {
    console.warn("Unslider needs jQuery");
    return;
  }

  const defaults = {
    autoplay: false,
    delay: 3000,
    speed: 750,
    keys: false,
    nav: false,
    dots: false,
  };

  class Unslider {
    constructor(context, options = {}) {
      this.$context = context;
      this.options = { ...defaults, ...options };
      this.current = 0;
      this.total = 0;
      this.interval = null;
      this.keyHandler = null;
      this.$parent = null;
      this.$container = null;
      this.$slides = $();
      this.$nav = null;

      this.init();
    }

    init() {
      this.$container = this.$context.find("ul").first();
      this.$slides = this.$container.children("li");
      this.total = this.$slides.length;

      if (this.total === 0) return;

      if (!this.$context.parent().hasClass("unslider")) {
        this.$context.wrap('<div class="unslider" />');
      }

      this.$parent = this.$context.parent(".unslider");

      this.$context
        .addClass("unslider-horizontal")
        .css("overflow", "hidden");

      if (this.$context.css("position") === "static") {
        this.$context.css("position", "relative");
      }

      this.$container
        .addClass("unslider-wrap unslider-carousel")
        .css({
          display: "flex",
          width: `${this.total * 100}%`,
          margin: 0,
          padding: 0,
          listStyle: "none",
        });

      this.$slides.css({
        flex: `0 0 ${100 / this.total}%`,
        listStyle: "none",
      });

      this.buildNav();
      this.bindKeyboard();
      this.render();

      if (this.options.autoplay) {
        this.start();
      }
    }

    update(options = {}) {
      this.options = { ...this.options, ...options };

      if ((this.options.nav || this.options.dots) && !this.$nav) {
        this.buildNav();
      }

      if (this.options.keys && !this.keyHandler) {
        this.bindKeyboard();
      }

      this.render();

      if (this.options.autoplay) {
        this.start();
      } else {
        this.stop();
      }
    }

    buildNav() {
      if (!(this.options.nav || this.options.dots) || this.total <= 1 || this.$nav) return;

      const items = this.$slides
        .map((index) => `<li data-slide="${index}">${index + 1}</li>`)
        .get()
        .join("");

      this.$nav = $(`<nav class="unslider-nav"><ol>${items}</ol></nav>`);
      this.$parent.append(this.$nav);

      this.$nav.on("click", "li", (event) => {
        const slideIndex = Number($(event.currentTarget).attr("data-slide"));
        this.go(slideIndex);
      });
    }

    bindKeyboard() {
      if (!this.options.keys || this.keyHandler) return;

      this.keyHandler = (event) => {
        if (event.key === "ArrowLeft") this.prev();
        if (event.key === "ArrowRight") this.next();
      };

      $(document).on("keydown.unslider", this.keyHandler);
    }

    render() {
      if (this.total === 0) return;

      const offset = -(this.current * 100) / this.total;

      this.$container.css({
        transform: `translateX(${offset}%)`,
        transition: `transform ${this.options.speed}ms ease`,
      });

      this.$slides.removeClass("unslider-active").eq(this.current).addClass("unslider-active");

      if (this.$nav) {
        this.$nav.find("li").removeClass("unslider-active").eq(this.current).addClass("unslider-active");
      }
    }

    go(index) {
      if (this.total === 0) return;

      this.current = (index + this.total) % this.total;
      this.render();
      this.restartAutoplay();
    }

    next() {
      this.go(this.current + 1);
    }

    prev() {
      this.go(this.current - 1);
    }

    start() {
      this.stop();

      if (this.total <= 1) return;

      this.interval = window.setInterval(() => {
        this.next();
      }, this.options.delay);
    }

    stop() {
      if (!this.interval) return;

      window.clearInterval(this.interval);
      this.interval = null;
    }

    restartAutoplay() {
      if (this.options.autoplay) {
        this.start();
      }
    }
  }

  $.fn.unslider = function (options = {}) {
    return this.each(function () {
      const element = $(this);
      const instance = element.data("unslider");

      if (instance) {
        instance.update(options);
        return;
      }

      element.data("unslider", new Unslider(element, options));
    });
  };
})(window.jQuery);
